import { useEffect } from 'react';
const PIXEL_ID = '2095498077846022';
const SCRIPT_ID = 'meta-pixel-script';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return; /* eslint-disable */
    // Meta Pixel Code
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.id = SCRIPT_ID;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode?.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-36" data-mp="1iepfloebagg0">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-37" data-mp="1if90ndz9dky9" />
    </noscript>;
}